function swup_scripts() {
    
    const selector = 'body script:not([data-swup-ignore-script])';
    const scripts = Array.from(document.querySelectorAll(selector));
    scripts.forEach((script) => {
        const element = document.createElement('script');
        for (const { name, value } of script.attributes) {
            element.setAttribute(name, value);
        }
        element.textContent = script.textContent;
        script.replaceWith(element);
    });

}